export const BRAND_NAME = 'FinMudra';
export const LOGO_URL = '/finmudra-logo.png';
export const LOGO_ALT = 'FinMudra Credit Pvt Ltd';
export const CARE_EMAIL = 'Care@cashgo.in';
export const SUPPORT_EMAIL = 'support@cashgo.in';
export const SUPPORT_PHONE = '+91 8796782220';
export const WHATSAPP_NUMBER = '919997842548'; // Used in links (wa.me/91...)
export const WHATSAPP_DISPLAY = '+91-9997842548';
export const COMPANY_LEGAL_NAME = 'MLB Securities Pvt. Ltd.';
export const ADDRESS_MAIN = 'C-74, Sector 63, Noida, Uttar Pradesh 201301, India';
export const ADDRESS_SECONDARY = '302, Pratap Chambers, Karol Bagh, New Delhi - 110005';
